'use client'
import Link from 'next/link'
import BannerLandingPage from '@/components/landing-page/banner'
import { Button, buttonVariants } from '@/components/ui/button'
import Image from 'next/legacy/image'
import { Navbar } from '@/components/landing-page/navbar'
import { Suspense, useState } from 'react'
import { Sidebar } from '@/components/landing-page/sidebar'

export default function Layout({ children }: { children: React.ReactNode }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev)
  }
  const closeSidebarOnly = () => {
    setIsSidebarOpen(false)
  }

  return (
    <>
      <Sidebar isSideBarOpen={isSidebarOpen} closeSidebar={toggleSidebar} closeSidebarOnly={closeSidebarOnly} />
      <div className="relative overflow-hidden" data-aos="fade">
        <Suspense>
          <Navbar toggleSidebar={toggleSidebar} />
        </Suspense>
      </div>

      <main>{children}</main>
    </>
  )
}
